import { render, staticRenderFns } from "./MppAppPage.vue?vue&type=template&id=201b06dc&scoped=true"
import script from "./MppAppPage.vue?vue&type=script&lang=js"
export * from "./MppAppPage.vue?vue&type=script&lang=js"
import style0 from "./MppAppPage.vue?vue&type=style&index=0&id=201b06dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b06dc",
  null
  
)

export default component.exports